import $ from 'jquery'
import '@/views/Report/ReportEditor/js/barCodeLib/jquery-barcode.js'
import PDF417 from '@/views/Report/ReportEditor/js/barCodeLib/pdf417-js.js'
import errorBarCode from '@/assets/images/errorBarCode.svg'
import extend from '@/views/Report/ReportEditor/js/extend.js'
import formatConverter from '@/views/Report/ReportEditor/js/formatConverter.js'
import { qrcanvas } from 'qrcanvas'

var barCodeList={
  'error':errorBarCode
}

var getGuid = () => {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8)
      return v.toString(16).toLowerCase()
  })
}

export default {
  createBarCode: (info, value, setting) => {
    var barCodeBoard
    var defaultSetting = {
      bgColor: '#FFFFFF',
      color: '#000000',
      output: 'svg',
      showHRI: true
    }
    try {
      if (info.type.toLowerCase() === 'ean13') {
        if ((value || '').toString().length !== 13) {
          info.errorCode = 11
          return {
            url: extend.getFileURL(formatConverter.base64ToBlob(errorBarCode)),
            file:'error'
          }
        }
      }
      switch (info.type.toLowerCase()) {
        case 'codabar':
        case 'code39':
        case 'code128':
        case 'ean13':
        case 'msi':
        case 'datamatrix':
          barCodeBoard = document.createElement('div')
          $(barCodeBoard).barcode(value.toString(), info.type.toLowerCase(), Object.assign(defaultSetting, setting || {}))
          if (barCodeBoard.lastChild) {
            const guid=getGuid()
            barCodeList[guid]=formatConverter.base64ToBlob(barCodeBoard.lastChild.src)
            return {
              url: extend.getFileURL(barCodeList[guid]),
              ratio: barCodeBoard.lastChild.width / barCodeBoard.lastChild.height,
              file: guid
            }
          } else {
            info.errorCode = 21
            return {
              url: extend.getFileURL(formatConverter.base64ToBlob(errorBarCode)),
              file:'error'
            }
          }
        case 'qrcode':
          barCodeBoard = qrcanvas({
            data: value.toString()
          })
          const guid=getGuid()
          barCodeList[guid]=formatConverter.base64ToBlob(barCodeBoard.toDataURL())
          return {
            url: extend.getFileURL(barCodeList[guid]),
            ratio: 1,
            file:guid
          }
        case 'pdf417':
          PDF417.PDF417.init(value.toString())
          var barcode = PDF417.PDF417.getBarcodeArray()
          var bw = 2
          var bh = 2
          try {
            barCodeBoard = document.createElement('canvas')
            barCodeBoard.width = bw * barcode['num_cols']
            barCodeBoard.height = bh * barcode['num_rows']
            var ctx = barCodeBoard.getContext('2d')
            var y = 0
            for (var r = 0; r < barcode['num_rows']; ++r) {
              var x = 0
              for (var c = 0; c < barcode['num_cols']; ++c) {
                if (+barcode['bcode'][r][c] === 1) {
                  ctx.fillRect(x, y, bw, bh)
                }
                x += bw
              }
              y += bh
            }
            const guid=getGuid()
            barCodeList[guid]=formatConverter.base64ToBlob(barCodeBoard.toDataURL() || errorBarCode)
            return {
              url: extend.getFileURL(barCodeList[guid]),
              ratio: barCodeBoard.width / barCodeBoard.height,
              file:guid
            }
          } catch (ex) {
            return {
              url: extend.getFileURL(formatConverter.base64ToBlob(errorBarCode)),
              file:'error'
            }
          }
        default:
          return { url: '' }
      }
    } catch (e) {
      return { url: '' }
    }
  },
  barCodeList
}
